import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
/*Automatically created with https://github.com/facebook/create-react-app*/
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App/>);